<template>
    <div class="trainList">
        <ul class="wrap_ul">
            <template v-for="(item, index) in dataArray">
                <li class="wrap_t" :key="index" @click="popUp">
                    <div class="wrap_img">
                        <el-image :src="pic + item.avatar" lazy draggable="false"></el-image>
                        <span :class="{active:changeState(item.endTime)}">{{changeState(item.endTime) ? '火热报名' : '已结束'}}</span>
                    </div>
                    <div class="wrap_desc">
                        <p class="t_tit" :title="item.title">{{item.title}}</p>
                        <div>
                            <img src="../../assets/img/time.png" draggable="false" />
                            {{item.beginTime}}至{{item.endTime}}
                        </div>
                        <div>
                            <img src="../../assets/img/local.png" draggable="false" />
                            {{item.local}}
                        </div>
                    </div>
                </li>
            </template>
        </ul>
        <PopUpWin :isPop.sync="isShow" :tipWord="tips" :codeUrl="url" @closePop="isShow=false" />
    </div>
</template>

<script>
import PopUpWin from "./PopUpWin";

export default {
    name: "TrainList",
    props: ["dataArray"],
    data() {
        return {
            isShow: false,
            pic: "https://www.orthoday.com/SDpic/common/picSelect?gid=",
            timeStamp: 0,
            tips: "微信扫码查看课程详情",
            url: "http://bonetoday.com/conferenceLists.html"
        };
    },
    components: { PopUpWin },
    created() {
        this.getNowFormatDate();
    },
    computed: {
        changeState() {
            return item => {
                let n = this.timeStamp,
                    tmp = new Date(item).getTime();
                return tmp > n ? true : false;
            };
        }
    },
    methods: {
        getNowFormatDate() {
            let t = new Date(),
                y = t.getFullYear(),
                m = t.getMonth() + 1,
                d = t.getDate();
            if (m < 10) m = "0" + m;
            if (d < 10) d = "0" + d;
            let dateStr = y + "-" + m + "-" + d,
                tmp = new Date(dateStr).getTime();
            this.timeStamp = tmp;
        },
        popUp() {
            this.isShow = true;
        }
    }
};
</script>

<style scoped src="../../assets/css/train-list.css"></style>